import { type TypePolicy } from '@apollo/client';

export const Student: TypePolicy = {
    fields: {
        lastCertificate: {
            merge: true,
        },
    },
};
